import React from "react";
import { Box, Paper } from "@mui/material";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import DescriptionIcon from "@mui/icons-material/Description";
import { SectionTitle } from "./StyledComponents";

const RecipeDescription = ({ description }) => {
  if (!description) {
    return null;
  }

  return (
    <Box sx={{ mb: 3 }}>
      <SectionTitle variant="h5">
        <DescriptionIcon />
        Description
      </SectionTitle>
      <Paper
        variant="outlined"
        sx={{
          borderRadius: 2,
          p: 2,
          mt: 2,
          backgroundColor: "background.paper",
        }}
      >
        <Box
          sx={{
            "& p": {
              mb: 1,
              lineHeight: 1.6,
            },
            "& ul, & ol": {
              pl: 2,
              mb: 2,
            },
          }}
        >
          <ReactMarkdown remarkPlugins={[remarkGfm]}>
            {description}
          </ReactMarkdown>
        </Box>
      </Paper>
    </Box>
  );
};

export default RecipeDescription;
